import { Grid, GridItem, NestedCard, Stack } from '@optimus-web/core';
import { WithServiceId } from '@mews-commander/types';
import { isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled } from '@mews-commander/legacy-entities/src/selectors/session/subscription';
import { getRate } from '@mews-commander/legacy-entities/src/ducks/rates';
import { useCommanderSelector } from '@mews-commander/utils';
import RateInfo from '../RateInfo';
import { isAvailabilityEdited } from '../../selectors';
import { useAvailabilityBlockInfo } from '../../utils/useAvailabilityBlockInfo';
import { DateRange } from './DateRange';
import { ReleasedDate } from './ReleaseDate';
import { PickupDistributionInfo } from './PickupDistributionInfo';

interface AvailabilityBlockDatesProps extends WithServiceId {
    availabilityBlockId: string;
    serviceId: string;
}

export const AvailabilityBlockDates = ({ availabilityBlockId, serviceId }: AvailabilityBlockDatesProps) => {
    const isEditingAvailability = useCommanderSelector((state) => isAvailabilityEdited(state, { availabilityBlockId }));

    const advancedBlockFeaturesEnabled = useCommanderSelector<boolean>(
        isCurrentEnterpriseAvailabilityBlockAdvancedFeaturesEnabled
    );

    const { availabilityBlock } = useAvailabilityBlockInfo(availabilityBlockId);

    const rate = useCommanderSelector(
        (state) => availabilityBlock && getRate(state, { rateId: availabilityBlock?.rateId })
    );

    if (!availabilityBlock || !rate) {
        return null;
    }

    const { rateId, pickupDistribution } = availabilityBlock;

    return (
        <NestedCard fill>
            <Grid
                templateColumns={`repeat(${advancedBlockFeaturesEnabled ? 4 : 3}, minmax(0, 1fr))`}
                tabletMax={{ templateColumns: '1fr' }}
                divider="vertical"
                height="100%"
            >
                <GridItem data-test-date-range>
                    <Stack spacing="100" itemAlignment="center" fill>
                        <DateRange availabilityBlockId={availabilityBlockId} serviceId={serviceId} />
                    </Stack>
                </GridItem>
                {advancedBlockFeaturesEnabled && (
                    <GridItem data-test-pickup-distribution>
                        <PickupDistributionInfo pickupDistribution={pickupDistribution} />
                    </GridItem>
                )}
                <GridItem data-test-release>
                    <Stack spacing="200" itemAlignment="center" fill>
                        <ReleasedDate
                            availabilityBlockId={availabilityBlockId}
                            isEditingAvailability={isEditingAvailability}
                        />
                    </Stack>
                </GridItem>
                <GridItem data-test-rate>
                    <RateInfo availabilityBlockId={availabilityBlockId} rateId={rateId} editable={!rate.isDeleted} />
                </GridItem>
            </Grid>
        </NestedCard>
    );
};
